import React from 'react';
import EmptyStateCard from '@/views/components/misc/EmptyStateCard';

type Props = {
  hasContacts: boolean;
  onCreateContact: () => void;
};

enum EmptyStateType {
  NO_CONTACT = 'NO_CONTACT',
}

const AssignContactEmptyPage: React.FC<Props> = ({ hasContacts, onCreateContact }: Props) => {
  const i18nEmptyStatePath = 'EmptyStateCard.Planning.AssignContact';

  const emptyStateDefinition = {
    [EmptyStateType.NO_CONTACT]: {
      titlePath: `${i18nEmptyStatePath}.NoContact.Title`,
      messagePath: `${i18nEmptyStatePath}.NoContact.Message`,
      primaryButton: { label: `${i18nEmptyStatePath}.NoContact.PrimaryButtonText`, onClick: () => onCreateContact() },
    },
  };

  return <>{!hasContacts ? <EmptyStateCard {...emptyStateDefinition[EmptyStateType.NO_CONTACT]} /> : null}</>;
};

export default AssignContactEmptyPage;
